import React from "react";
import { Box } from "@material-ui/core";
import useStyleViewResearch from "../styles/useStyleViewResearch";
import Navbar from "./Navbar";
import Ricerca from "./Ricerca";
import Footer from "./Footer";

const ViewResearch = (props) => {
  const classes = useStyleViewResearch();
  return (
    <>
      <Box className={classes.wrapper}>
        <Navbar />
        <Ricerca {...props} />
        <Footer />
      </Box>
    </>
  );
};

export default ViewResearch;
